import { createFileRoute } from '@tanstack/react-router'
import { requireAuth, requireGuest } from '@/lib/middleware'
import { AuthLayout } from '@/components/layout/auth-layout'

export const Route = createFileRoute('/(auth)')({
  beforeLoad: async () => {
    return await requireGuest()
  },
  component: AuthLayout,
})
